module.exports = __webpack_public_path__ + "static/img/04.6cd11535.png";